'use client';
import React, { useEffect } from 'react';

import loadBackgroudImages from '../../common/loadBackgroudImages';
function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);

  const handleScrollClick = (e) => {
    e.preventDefault();
    const targetId = '#nosotros';
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const navbar = document.querySelector('.navbar');
      const navbarHeight = navbar ? navbar.offsetHeight : 0;
      const targetPosition = targetElement.offsetTop - navbarHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };
  return (
    <header
      id="inicio"
      className=" main-header bg-img valign"
      data-background="/assets/imgs/blog/3.jpg"
      data-overlay-dark="5"
    >
      <div className="container ontop">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="caption text-center">
              <h1 className="text-center">
                Bienvenido a <br /> Cítricos Naturales
              </h1>
              <div className="text mt-30">
                <p className="text-center">
                  <span className="text-light fw-600">
                    Zumos y jugos hechos con fruta fresca seleccionada para ofrecerte el mejor sabor.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-80">
          <div className="col-lg-12">
            <div className="scroll-indicator d-flex justify-content-center">
              <a href="#nosotros" className="animated-arrow" onClick={handleScrollClick}>
                <svg 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    d="M7 10L12 15L17 10" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <style jsx>{`
          .scroll-indicator {
            position: relative;
          }
          .animated-arrow {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            color: #fff;
            cursor: pointer;
            transition: all 0.3s ease;
            opacity: 0.7;
            text-decoration: none;
          }
          .animated-arrow:hover {
            opacity: 1;
          }
          .animated-arrow svg {
            animation: bounceArrow 2s ease-in-out infinite;
          }
          @keyframes bounceArrow {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(8px);
            }
          }
        `}</style>
      </div>
    </header>
  );
}

export default Header;
